import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  Icon,
  Image,
  SimpleGrid,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Header } from "../../components/Header";
import { Sidebar } from "../../components/Sidebar";
import { useHistory, useParams } from "react-router-dom";
import { api } from "../../services/api";
import { RiArrowLeftLine } from 'react-icons/ri';
import { format } from "date-fns";
import MapsModal from "../../components/MapsModal";
import { MdLocationOn } from 'react-icons/md';
import { ImagePreview } from "../../components/ImagePreview";

interface IPhoto {
  _id: string;
  filename: string,
  latitude: number,
  longitude: number
}
interface IStep {
  _id: string;
  type: 'loadingLocation' | 'startLoading' | 'startTrip' | 'offloadingLocation' | 'startOffloading' | 'endOffloading';
  sentAt: string;
  photos: IPhoto[];
}

const mapping = {
  loadingLocation: 'Local Carregamento',
  startLoading: 'Iniciar Carregamento',
  startTrip: 'Iniciar Viagem',
  offloadingLocation: 'Local da Descarga',

  startOffloading: 'Inicio da Descarga',

  endOffloading: 'Fim da Descarga',
}

  
export default function Steps() {
  const [list, setList] = useState<IStep[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState<IPhoto>({} as IPhoto);
  const { id } = useParams<{id: string}>();
  const history = useHistory();
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const isMdVersion = useBreakpointValue({
    base: false,
    md: true,
  });

  const isSmVersion = useBreakpointValue({
    base: false,
    sm: true,
  });

  useEffect(() => {
    const loadList = async () => {
      const { data } = await api.get('/steps', {params: {eventId: id}});
      setList(data);
    }
    loadList();
  },[id]);

  const handleBackClick = () => {
    history.goBack();
  }
  
  const handleCloseModal = () => {
    setShowModal(false);
  }
  const handleOpenModal = (photo: IPhoto) => {
    setShowModal(true);
    setSelectedPhoto(photo);
  }

  

  return (
    <>
    <Flex direction="column" minH="100vh" bg="bg">
      <Header />

      <Flex w="100%" maxWidth={1460} px={isMdVersion ? "10" : "3"} >
        <Sidebar />

        <Box overflowX="auto" flex="1" borderRadius={8} bg="gray" p="6" mb="5">
          {isWideVersion && (
            <Flex mb="8" justify="space-between" align="center" justifyContent="flex-start">
              <Button onClick={handleBackClick}>
                <Icon as={RiArrowLeftLine} fontSize="29" color="text" />
              </Button>
              <Heading fontSize='21'  fontWeight="400" color="text">
                Registros
              </Heading>
            </Flex>
          )}
          {
            list.map(item => (
              <>
                <div style={{marginTop: '16px'}}>
                  <Text lineHeight='1.1' fontSize={'large'} color="text">{mapping[item.type]}</Text>
                  <Text lineHeight='1.1' fontSize={'md'} color="text">{format(new Date(item.sentAt), 'dd/MM/yyyy HH:mm:ss')} </Text>
                  <SimpleGrid columns={3} columnGap={6} style={{marginTop: '16px' }}> 
                    {item.photos.map(photo => (     
                        <ImagePreview 
                          photo={{
                            _id: photo._id,
                            latitude: photo.latitude,
                            longitude: photo.latitude,
                            filename: photo.filename
                          }} 
                          openModal={() => handleOpenModal(photo)} 
                        />
                    ))}

                  </SimpleGrid>
                </div>

                <Divider color="white" />
              </>
              
              
            ))
          }



          <span></span>
        </Box>
      </Flex>
    </Flex>
    {showModal && (
      <MapsModal onClose={handleCloseModal} latitude={selectedPhoto.latitude} longitude={selectedPhoto.longitude} />
    )}
    
    </>
  );
}
  